/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Pose_Reason_Body_Not_VisibleInputs */

const en_us2_body_assessment_pose_reason_body_not_visible = /** @type {(inputs: Body_Assessment_Pose_Reason_Body_Not_VisibleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your whole body wasn't in the photo. Step back until your head and feet fit in the frame, about 2 m from the phone.`)
};

const pt_br2_body_assessment_pose_reason_body_not_visible = /** @type {(inputs: Body_Assessment_Pose_Reason_Body_Not_VisibleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O corpo não apareceu inteiro. Afaste-se até a cabeça e os pés caberem no enquadramento, a uns 2 m do celular.`)
};

const es_419_body_assessment_pose_reason_body_not_visible = /** @type {(inputs: Body_Assessment_Pose_Reason_Body_Not_VisibleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu cuerpo no salió entero en la foto. Aléjate hasta que la cabeza y los pies quepan en el encuadre, a unos 2 m del teléfono.`)
};

const pt_pt2_body_assessment_pose_reason_body_not_visible = /** @type {(inputs: Body_Assessment_Pose_Reason_Body_Not_VisibleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O corpo não apareceu inteiro. Afasta-te até a cabeça e os pés caberem no enquadramento, a uns 2 m do telemóvel.`)
};

const fr_fr2_body_assessment_pose_reason_body_not_visible = /** @type {(inputs: Body_Assessment_Pose_Reason_Body_Not_VisibleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ton corps n'était pas entier sur la photo. Recule jusqu'à ce que ta tête et tes pieds tiennent dans le cadre, à environ 2 m du téléphone.`)
};

const de_de2_body_assessment_pose_reason_body_not_visible = /** @type {(inputs: Body_Assessment_Pose_Reason_Body_Not_VisibleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein ganzer Körper war nicht im Bild. Geh zurück, bis Kopf und Füße ins Bild passen, etwa 2 m vom Handy entfernt.`)
};

const it_it2_body_assessment_pose_reason_body_not_visible = /** @type {(inputs: Body_Assessment_Pose_Reason_Body_Not_VisibleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il corpo non era tutto nella foto. Allontanati finché testa e piedi entrano nell'inquadratura, a circa 2 m dal telefono.`)
};

/**
* | output |
* | --- |
* | "Your whole body wasn't in the photo. Step back until your head and feet fit in the frame, about 2 m from the phone." |
*
* @param {Body_Assessment_Pose_Reason_Body_Not_VisibleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_pose_reason_body_not_visible = /** @type {((inputs?: Body_Assessment_Pose_Reason_Body_Not_VisibleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Pose_Reason_Body_Not_VisibleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_pose_reason_body_not_visible(inputs)
	if (locale === "es-419") return es_419_body_assessment_pose_reason_body_not_visible(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_pose_reason_body_not_visible(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_pose_reason_body_not_visible(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_pose_reason_body_not_visible(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_pose_reason_body_not_visible(inputs)
	return en_us2_body_assessment_pose_reason_body_not_visible(inputs)
});
export { body_assessment_pose_reason_body_not_visible as "body-assessment.pose_reason.body_not_visible" }